import { useState, useEffect } from "react";
import "../styles/Couples.css";
import { FaWheelchair } from "react-icons/fa";
import SlideShow from "../components/SlideShow";

export default function Couples() {
  const [couplesHeader, setCouplesHeader] = useState([]);
  const [awardData, setAwardData] = useState([]);
  const [bohemian, setBohemian] = useState([]);
  const [cabana, setCabana] = useState([]);
  const [height, setHeight] = useState([]);
  const [signature, setSignature] = useState([]);
  const [table, setTable] = useState([]);
  const [teePee, setTeePee] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      try {
        const [couplesRes, awardRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/images/couples`),
          fetch(`${process.env.REACT_APP_API_URL}/api/images/main`),
        ]);

        if (!couplesRes.ok) {
          throw new Error(couplesRes.message || " Failed to fetch images");
        }
        if (!awardRes.ok) {
          throw new Error(awardRes.message || " Failed to fetch images");
        }

        const couplesData = await couplesRes.json();
        const awardData = await awardRes.json();

        setCouplesHeader(couplesData.data.header);
        setBohemian(couplesData.data.bohemian);
        setCabana(couplesData.data.cabana);
        setHeight(couplesData.data.height);
        setSignature(couplesData.data.signature);
        setTable(couplesData.data.table);
        setTeePee(couplesData.data.teepee);
        setAwardData(awardData.data.award);
      } catch (err) {
        setError(err || "Failed to fetch images");
      } finally {
        setLoading(false);
      }
    };
    fetchImages();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Unable to load images.</div>;
  }

  return (
    <div className="couples">
      {/* Couples Header */}
      <section className="couples__intro--container">
        <div className="couples__intro--header">
          <img
            src={couplesHeader[0]?.src}
            alt={couplesHeader[0]?.alt}
            className="couples__intro--header-image"
          />
          <div className="couples__intro--text">
            <h1>Picnics For Couples</h1>
            <p>Escape the ordinary with a romantic picnic made just for two</p>
          </div>
          <div className="couples_award--container-right">
            <img
              src={awardData[2]?.src}
              alt={awardData[2]?.alt}
              className="couples__intro--header-image"
            />
          </div>
        </div>

        <div className="couples__intro--content">
          <h2>An Elevated Escape for Two</h2>
          <p>
            Indulge in an unforgettable experience with our Luxury Couples
            Picnic — where elegance and intimacy meet in perfect harmony. Set
            against a stunning natural backdrop, each picnic is exquisitely
            styled with premium décor, plush seating, and every detail curated
            to perfection. Whether you're celebrating a special occasion or
            simply enjoying each other's company, this is relaxation reimagined
            in the most luxurious way.
          </p>
        </div>
      </section>

      {/* Couples Picnic Options */}
      <section className="couples__container">
        {/* Bohemian */}
        <div className="couples__picnic--container">
          <div className="couples__picnic--image">
            <SlideShow slides={bohemian} />
          </div>

          <div className="couples__picnic--details">
            <div className="couples__picnic--header">
              <h2>Bohemian Luxury for Two $195</h2>
            </div>
            <p>
              A relaxed yet refined bohemian picnic — perfect for two.
              Thoughtfully styled for a carefree, intimate experience, this
              laid-back setting invites you to unwind and soak in the stunning
              coastal beauty of Bribie Island in true boho style.
            </p>
            <h3>
              <strong>Picnic Inclusions</strong>
            </h3>
            <div className="couples__picnic--inclusions">
              <ul>
                <li>Australian-designed bohemian picnic rug</li>
                <li>Small low-lying picnic tables</li>
                <li>Layered cushions and throws</li>
                <li>Outdoor umbrella</li>
                <li>Artificial & dried floral arrangement</li>
                <li>Table runner & styled décor</li>
                <li>Bohemian glass goblets</li>
              </ul>
              <ul>
                <li>Pressed napkins</li>
                <li>Elegant dinnerware</li>
                <li>Gold cutlery</li>
                <li>Ambient lighting</li>
                <li>Bluetooth speaker</li>
                <li>Picnic basket with hand sanitizer, wipes,</li>
                <li>bottle opener, magazines & table games</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Elegant Height */}
        <div className="couples__picnic--container reverse">
          <div className="couples__picnic--image">
            <SlideShow slides={height} />
          </div>
          <div className="couples__picnic--details">
            <div className="couples__picnic--header">
              <h2>Elegant Dining Height Picnic $195 </h2>
              <div className="couples__picnic--header-access">
                <FaWheelchair className="couples___picnic--header-accessability" />
              </div>
            </div>
            <p>
              A romantic and elegant dining-height picnic — perfect for two.
              Designed with accessibility in mind, this elevated setting allows
              you to enjoy a comfortable, intimate dining experience while
              taking in the breathtaking views of Bribie Island's stunning
              coastline.
            </p>
            <h3>
              <strong>Picnic Inclusions</strong>
            </h3>
            <div className="couples__picnic--inclusions">
              <ul>
                <li>Dining height table </li>
                <li>Comfortable dining chairs</li>
                <li>Outdoor Umbrella </li>
                <li>Layered cushions and throws</li>
                <li>Artificial floral arrangement</li>
                <li>Premium glassware</li>
                <li>(champagne/wine glasses and tumblers)</li>
              </ul>
              <ul>
                <li>Tablecloth, table runner & styled décor</li>
                <li>Pressed napkins</li>
                <li>Elegant placemat, dinnerware & gold cutlery</li>
                <li>Ambient lighting</li>
                <li>Bluetooth speaker</li>
                <li>Picnic basket with hand sanitizer, wipes,</li>
                <li>bottle opener, magazines & table games</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Picnic Table*/}
        <div className="couples__picnic--container">
          <div className="couples__picnic--image">
            <SlideShow slides={table} />
          </div>
          <div className="couples__picnic--details">
            <div className="couples__picnic--header">
              <h2>Couples Picnic Table $250</h2>
              <div className="couples___container--heading-access"></div>
            </div>
            <p>
              A dreamy, intimate picnic for two set against the stunning
              backdrop of Bribie Island. Relax at your own styled picnic table
              setting and soak in the coastal charm with someone special.
            </p>
            <h3>
              <strong>Picnic Inclusions</strong>
            </h3>
            <div className="couples__picnic--inclusions">
              <ul>
                <li>Low-lying picnic table</li>
                <li>Rugs, Cushions and throws</li>
                <li>Low lying Chairs</li>
                <li>Artificial floral arrangement</li>
                <li>Tablecloth, table runner & styled decor</li>
                <li>Quality glassware</li>
                <li>(champagne or wine and tumblers)</li>
              </ul>
              <ul>
                <li>Placemats & Pressed napkins</li>
                <li>Elegant dinnerware & gold cutlery</li>
                <li>Ambient lighting</li>
                <li>Umbrella (weather permitting)</li>
                <li>Bluetooth speaker</li>
                <li>Picnic basket with hand sanitizer, wipes,</li>
                <li>bottle opener, magazines & table games</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Coastal Cabana */}
        <div className="couples__picnic--container reverse">
          <div className="couples__picnic--image">
            <SlideShow slides={cabana} />
          </div>

          <div className="couples__picnic--details">
            <div className="couples__picnic--header">
              <h2>Couples Luxury Coastal Cabana $300</h2>
              <div className="couples___container--heading-access"></div>
            </div>
            <p>
              Escape to a dreamy, intimate setting designed just for two.
              Nestled under our luxurious coastal fringed cabana, you'll unwind
              at your own beautifully styled picnic table, surrounded by the
              charm of the sea Perfect for romance, celebration, or simply
              sharing a special moment together.
            </p>
            <h3>
              <strong>Picnic Inclusions</strong>
            </h3>
            <div className="couples__picnic--inclusions">
              <ul>
                <li>Luxury Coastal Blue & White Fringed Cabana</li>
                <li>Low-lying picnic table or small side tables</li>
                <li>Rugs, Cushions and throws</li>
                <li>Low lying Chairs or Layered cushions</li>
                <li>Artificial floral arrangement</li>
                <li>Quality glassware</li>
                <li>(champagne or wine and tumblers)</li>
              </ul>
              <ul>
                <li>Tablecloth, table runner & styled decor</li>
                <li>Placemats & Pressed napkins</li>
                <li>Elegant dinnerware & gold cutlery</li>
                <li>Ambient lighting</li>
                <li>Bluetooth speaker</li>
                <li>Picnic basket with hand sanitizer, wipes,</li>
                <li>bottle opener, magazines & couple games,</li>
                <li>Ice bucket with complimentary ice & sparkling water</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Laced TP */}
        <div className="couples__picnic--container">
          <div className="couples__picnic--image">
            <SlideShow slides={teePee} />
          </div>
          <div className="couples__picnic--details">
            <div className="couples__picnic--header">
              <h2>Couples' Luxury Lace Teepee $300</h2>
              <div className="couples___container--heading-access"></div>
            </div>
            <p>
              Escape into a delicate and romantic experience designed just for
              two. Nestled beneath our elegant white lace teepee, you'll unwind
              in your own beautifully styled picnic space—surrounded by the
              stunning natural beauty of Bribie Island. Whether you're
              celebrating love, marking a special milestone, or simply enjoying
              time together, this dreamy setting is perfect for connection,
              comfort, and heartfelt moments.
            </p>
            <h3>
              <strong>Picnic Inclusions</strong>
            </h3>
            <div className="couples__picnic--inclusions">
              <ul>
                <li>Luxury White Lace Teepee</li>
                <li>Choice of low-lying picnic table or small side tables</li>
                <li>Soft rugs, cushions, and throws for added comfort</li>
                <li>
                  Low-lying chairs or layered cushions for relaxed seating
                </li>
                <li>Elegant artificial floral arrangement</li>
                <li>Quality glassware</li>
                <li>(champagne/wine glasses and tumblers)</li>
              </ul>
              <ul>
                <li>Premium tablecloth, runner, and styled décor</li>
                <li>Placemats and pressed linen napkins</li>
                <li>Sophisticated dinnerware and gold cutlery</li>
                <li>Ambient lighting to set the mood</li>
                <li>Bluetooth speaker for your personal playlist</li>
                <li>Curated picnic basket including: Hand sanitizer & wipes</li>
                <li>bottle opener, magazines & Couple's games</li>
                <li>Ice bucket with: Complimentary ice & Sparkling water</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Signature */}
        <div className="couples__picnic--container reverse">
          <div className="couples__picnic--image">
            <SlideShow slides={signature} />
          </div>
          <div className="couples__picnic--details">
            <div className="couples__picnic--header">
              <h2>Couples Signature Cabana $350</h2>
              <div className="couples___container--heading-access"></div>
            </div>
            <p>
              Indulge in the ultimate romantic escape, thoughtfully curated for
              just the two of you. Nestled under our luxurious white fringed
              cabana, you'll relax in style at your own beautifully set picnic
              space—surrounded by the natural beauty of Bribie Island. Whether
              you're celebrating a special occasion or simply enjoying each
              other's company, this experience is all about connection, comfort,
              and coastal charm.
            </p>
            <h3>
              <strong>Picnic Inclusions</strong>
            </h3>
            <div className="couples__picnic--inclusions">
              <ul>
                <li>Luxury White Fringed Cabana</li>
                <li>Low-lying picnic table or small side tables</li>
                <li>Plush rugs, cushions, and throws</li>
                <li>Low-lying chairs or layered cushions</li>
                <li>Elegant artificial floral arrangement</li>
                <li>Quality glassware</li>
                <li>(champagne/wine glasses and tumblers)</li>
              </ul>
              <ul>
                <li>Premium tablecloth, runner, and styled décor</li>
                <li>Placemats and pressed linen napkins</li>
                <li>Stylish dinnerware and gold cutlery</li>
                <li>Ambient string or lantern lighting</li>
                <li>Bose Bluetooth speaker for your personal playlist</li>
                <li>Curated picnic basket including: Hand sanitizer & wipes</li>
                <li>bottle opener, magazines & Couple's games</li>
                <li>Ice bucket with: Complimentary ice & Sparkling water</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
